import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureMLWorkspaceIcon = props => (
  <Icon viewBox="0 -0.5 17 17" w="full" h="full" color="inherit" {...props}>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M12,1 L12,0.023 L6,0.023 C6,0.023 6,0.013 6,1 L7.012,1 L7.012,7 L3,15 C3,15 3,15.962 4,15.962 L14,15.962 C15,15.962 15,15 15,15 L10.958,7 L10.938,1 L12,1 L12,1 Z M14,15.031 L4,15.031 L8,7 L8,1 L10,1 L10,7 L14,15.031 L14,15.031 Z"
        fill="currentColor"
      ></path>
    </g>
  </Icon>
);
